module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_SL-bb570a91bb3ef7b822c93737e5632605.svg";